/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown>, amount: NonNullable<unknown>, time: NonNullable<unknown> }} Einvoice_Candidate_RowInputs */

const vi_einvoice_candidate_row = /** @type {(inputs: Einvoice_Candidate_RowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number} · ${i?.amount} đ · ${i?.time}`)
};

/**

* @param {Einvoice_Candidate_RowInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_candidate_row = /** @type {((inputs: Einvoice_Candidate_RowInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Candidate_RowInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_candidate_row(inputs)
});